import { render, staticRenderFns } from "./RightsEdit.vue?vue&type=template&id=fe1a7702&scoped=true&"
import script from "./RightsEdit.vue?vue&type=script&lang=js&"
export * from "./RightsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1a7702",
  null
  
)

export default component.exports